import Partition from "molecules/partition";
import React from "react";

const creditors = [
  {
    sno: "1",
    name: "VPFPC",
    amount: "38.74",
  },
  {
    sno: "2",
    name: "PAFPC",
    amount: "9.57",
  },
  {
    sno: "3",
    name: "Elephant Design Pvt. Ltd",
    amount: "8.14",
  },
  {
    sno: "4",
    name: "Bayspec Inc.",
    amount: "7.36",
  },
  {
    sno: "5",
    name: "Keyur Shah & Associates",
    amount: "7.02",
  },
  {
    sno: "6",
    name: "Mahaveer Enterprises",
    amount: "5.70",
  },
];



const CommitteeTable = ({ title , members } : {title  :string, members : any[]}) => (
  <div className="mt-6 mb-4 border border-green rounded-lg overflow-hidden shadow-sm">
    <h3 className="bg-green text-lg font-semibold text-white uppercase px-6 py-3 border-b border-gray-300">
      {title}
    </h3>
    <div className="overflow-x-auto">
    <table className="min-w-full text-left text-md text-black">
      <thead className="bg-green-100 text-green-900">
        <tr>
          <th className="px-6 py-3">S.No</th>
          <th className="px-6 py-3">Name</th>
          <th className="px-6 py-3">Amount (in Lakhs)</th>
        </tr>
      </thead>
      <tbody>
        {members.map((member : any, idx : number) => (
          <tr
            key={idx}
          >
            <td className="px-6 py-3">{member.sno}</td>
            <td className="px-6 py-3">{member.name}</td>
            <td className="px-6 py-3">{member.amount}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div> 
);

export default function CommiteeContent () {
  return (
    <>
    <div className="bg-gradient-to-r from-[#5D6A5D] to-[#193C34] w-full h-[64px] md:h-[80px] xl:h-[100px] 2xl:h-[90px]"></div>
    <section  className="bg-cream3 relative">
      
      <div className="p-6 max-w-5xl mx-auto text-[#101828]">
        <Partition color="dark" text="Material Creditors" />
      
        <CommitteeTable title="List of Material Creditors as on 31st Mar 2025" members={creditors} />
      </div>
    </section>
    </>
  );
};